// extracted by mini-css-extract-plugin
export default {"Container":"Answer_Container__Lzmjp","Progress":"Answer_Progress__enw4P","Stat":"Answer_Stat__4Q9CM"};